import React from 'react';
import { GradientBorder } from './GradientBorder';
import { gradients } from 'theme/tokens';
import './ErrorCard.css';

interface ErrorCardProps {
  pair: string;
  timeframe: string;
  attempts: number;
  onRetry: () => void;
  onOpenPair: (anchor: HTMLElement) => void;
  onOpenTf: (anchor: HTMLElement) => void;
}

/** Connection-timeout state, ported from the DataView error card. */
export function ErrorCard({
  pair,
  timeframe,
  attempts,
  onRetry,
  onOpenPair,
  onOpenTf,
}: ErrorCardProps) {
  return (
    <div className="error-container">
      <GradientBorder
        colors={gradients.borderAlerts}
        borderRadius={16}
        borderWidth={1.5}
        innerClassName="error-inner"
      >
        <div className="error-icon">⚠</div>
        <div className="error-title">Connection timed out</div>
        <div className="error-sub-a">
          We couldn't reach the analysis service for {pair} · {timeframe}.
        </div>
        <div className="error-sub-b">Tried {attempts} times automatically</div>
        <div className="error-pills">
          <button className="pill" type="button" onClick={(e) => onOpenPair(e.currentTarget)}>
            <span className="pill-text">{pair}</span>
            <span className="pill-caret">▾</span>
          </button>
          <button className="pill" type="button" onClick={(e) => onOpenTf(e.currentTarget)}>
            <span className="pill-text">{timeframe}</span>
            <span className="pill-caret">▾</span>
          </button>
        </div>
        <button className="retry-btn" type="button" onClick={onRetry}>
          ↻ Try again
        </button>
      </GradientBorder>
    </div>
  );
}
